// extracted by mini-css-extract-plugin
export var label = "_d2-2";
export var slideContainer = "_d2-0";
export var slider = "_d2-1";